export default "__VITE_ASSET__$H$Q4cNq__"